class DeniedDevicesDatatable {
    constructor(){
        this.organizationID = new URLSearchParams(window.location.search).get('organizationID');
        this.datatable = this.init('#denied-devices-datatable', this.organizationID);
        this.initActions(this.organizationID);
    }
    init(el, organizationID){
        let thisClass = this;
        const datatable =  $(el).DataTable({
            searchDelay: 400,
            processing: true,
            serverSide: true,
            stateSave: false,
            info: true,
            paging: true,
            order: [[3, 'desc']],
            ajax: {
                url: '?do=getDeniedDevices',
                type: 'POST',
                data: {
                    organizationID: organizationID
                }
            },
            select: {
                style: 'multi',
                selector: 'td:first-child input[type="checkbox"]',
                className: 'row-selected-light-primary-bg'
            },
            language: {
                emptyTable: "No data found"
            },
            dom:
                "<'table-responsive'tr>" +
                "<'row'" +
                "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'li>" +
                "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'p>" +
                ">",
            drawCallback: function(settings) {
                // Remove all visible popovers after datatable draw
                document.querySelectorAll('.popover.fade.show').forEach(function (el) {
                    el.remove();
                });
                // Init all popovers after datatable draw
                const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
                popoverTriggerList.map(function (popoverTriggerEl) {
                    new bootstrap.Popover(popoverTriggerEl);
                });
                // init page length select
                $('select[name=denied-devices-datatable_length]').select2({minimumResultsForSearch: -1});
            },
            columns: [
                {
                    data: 'uuid',
                    title: '<div class="form-check form-check-sm form-check-custom form-check-solid ga-border-primary-200 mx-1">\n' +
                        '       <input class="form-check-input cursor-pointer" type="checkbox" data-kt-check="true" data-kt-check-target="'+el+' .form-check-input" data-kt-check-all="true" value="1"/>\n' +
                        '   </div>',
                    sortable: false,
                    render: function (data, type, row) {
                        return '<div class="form-check form-check-sm form-check-custom form-check-solid ga-border-primary-200 mx-1">' +
                            '    <input class="form-check-input cursor-pointer" type="checkbox" value="' + row['uuid'] + '" '+(!row['edit'] ? 'disabled' : '')+'/>' +
                            '</div>';
                    }
                },
                {
                    data: 'uuid',
                    title: 'Device',
                    sortable: true,
                    className: 'min-w-150px',
                    render: function (data, type, row) {
                        return '<div class="d-flex align-items-center">' +
                            '       <div class="symbol symbol-40px me-3 border ga-border-primary-300 symbol-circle">' +
                            '           <div class="symbol-label bg-light-primary border border-2 border-white overflow-hidden'+(row['isBlocked'] ? ' filter-grayscale' : '')+'">' +
                            '               <img src="/media/goodaccess/icons/os/' + row['osName'] + '.svg" alt="avatar">' +
                            '           </div>' +
                            (row['isBlocked'] ? '<span class="symbol-badge badge badge-circle bg-danger start-85 top-85 w-15px h-15px fs-10 text-center text-white" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>blocked</div>">&#10005;</span>' : '') +
                            '       </div>' +
                            '       <div class="d-flex justify-content-start flex-column">' +
                            '           <span class="fw-bold text-primary fs-6" data-device-name="'+row['name']+'">'+row['name']+'</span>' +
                            '           <span class="fw-semibold d-block fs-7 ga-text-primary-800">' + row['osNameWithVersion'] +'</span>' +
                            '           <span class="fs-8 ga-text-primary-800">'+row['model']+'</span>' +
                            '       </div>' +
                            '   </div>';
                    }
                },
                {
                    data: 'members',
                    title: 'Members',
                    sortable: false,
                    render: function (data, type, row) {
                        if(row['members']){
                            let html = '<div class="symbol-group symbol-hover flex-nowrap">';
                            for (let i = 0; i < row['members'].length; i++) {
                                let avatarUrl = '/media/goodaccess/avatars/svg/device.svg';
                                if (row['members'][i]['avatarID'] || row['members'][i]['isIdp']) {
                                    avatarUrl = '/media/goodaccess/avatars/svg/Icon with face-' + row['members'][i]['avatarID'] + '.svg';
                                }

                                if (i < 3) {
                                    if (row['members'][i]['password'] || row['members'][i]['isIdp']) {
                                        html += `<div class="symbol symbol-40px symbol-circle border ga-border-primary-300" id="`+row['members'][i]['uuid']+`">` +
                                            (row['editMembers'] ? '<span class="edit-member">' : '') +
                                            `        <div class="symbol-label bg-light-primary border border-2 border-white`+(row['members'][i]['isBlocked'] === 1 ? ' filter-grayscale' : '')+(!row['members'][i]['hasGateway'] ? ' opacity-50' : '')+ `" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="`+ (!row['members'][i]['isIdp'] && !row['members'][i]['avatarID'] ? `<div class='fw-bold text-center'>` + row['members'][i]['username'] + (row['members'][i]['isOwner'] ?  `<span class='badge badge-light-danger badge-sm ms-2 align-center'>Owner</span>` : ``)+(row['members'][i]['managerRole'] ? `<span class='badge badge-light-danger badge-sm ms-2 align-center'>`+row['members'][i]['managerRole']+`</span>` : ``)+(row['members'][i]['meBadge'] ? `<span class='badge badge-light-danger badge-sm ms-2 align-center'>Me</span>` : ``) + `</div>` : `<div class='fw-bold text-center'>` + row['members'][i]['name'] + (row['members'][i]['isOwner'] ?  `<span class='badge badge-light-danger badge-sm ms-2 align-center'>Owner</span>` : ``)+(row['members'][i]['managerRole'] ? `<span class='badge badge-light-danger badge-sm ms-2 align-center'>`+row['members'][i]['managerRole']+`</span>` : ``)+(row['members'][i]['meBadge'] ? `<span class='badge badge-light-danger badge-sm ms-2 align-center'>Me</span>` : ``) + `</div><div class='fw-bold text-center'>` + row['members'][i]['username'] + `</div>`+ (row['members'][i]['lastDeviceUsage'] ? `<div class='fw-bold text-center'>Last attempt: ` + row['members'][i]['lastDeviceUsage']['dateTimeFormattedInline'] + `</div>` : ``)) +`<div class='text-center small'>`+new IdpBadgesGenerator().generateText(row['members'][i]['idps'])+`</div>">`+
                                            '             <img alt="avatar" class="h-40px" src="' + avatarUrl + '"/>' +
                                            '        </div>' +
                                            (row['editMembers'] ? '</span>' : '') +
                                            (!row['members'][i]['hasGateway'] ? '<span class="symbol-badge badge badge-circle bg-warning start-85 top-85 w-15px h-15px fs-7 text-center text-white" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>This Member is not assigned to any Gateway, so it does not have access to the perimeter</div>">!</span>' : '') +
                                            (row['members'][i]['isBlocked'] === 1 ? '<span class="symbol-badge badge badge-circle bg-danger start-85 top-85 w-15px h-15px fs-10 text-center text-white" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>blocked</div>">&#10005;</span>' : '') +
                                            (row['members'][i]['connected'] ? '<span class="symbol-badge badge badge-circle bg-success start-85 top-85 w-15px h-15px" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>connected</div>"></span>' : '') +
                                            '     </div>';
                                    } else {
                                        html += `<div class="symbol symbol-40px symbol-circle border ga-border-primary-300">` +
                                            `        <div class="symbol-label bg-light-primary border border-2 border-white`+(row['members'][i]['isBlocked'] === 1 ? ' filter-grayscale' : '')+(!row['members'][i]['hasGateway'] ? ' opacity-50' : '')+`" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="`+ (!row['members'][i]['isIdp'] && !row['members'][i]['avatarID'] ? `<div class='fw-bold text-center'>` + row['members'][i]['username'] + (row['members'][i]['isOwner'] ?  `<span class='badge badge-light-danger badge-sm ms-2 align-center'>Owner</span>` : ``)+(row['members'][i]['managerRole'] ? `<span class='badge badge-light-danger badge-sm ms-2 align-center'>`+row['members'][i]['managerRole']+`</span>` : ``)+(row['members'][i]['meBadge'] ? `<span class="badge badge-light-danger badge-sm ms-2 align-center">Me</span>` : ``) + `</div>` : `<div class='fw-bold text-center'>` + row['members'][i]['name'] + (row['members'][i]['isBlocked'] ? ' (blocked)' : '') + (row['members'][i]['connected'] ? ' (connected)' : '') + `</div><div class='fw-bold text-center'>` + row['members'][i]['username'] + `</div>` + (row['members'][i]['lastDeviceUsage'] ? `<div class='fw-bold text-center'>Last attempt: ` + row['members'][i]['lastDeviceUsage']['dateTimeFormattedInline'] + `</div>` : ``)) +`<div class='text-center small'>`+new IdpBadgesGenerator().generateText(row['members'][i]['idps'])+`</div>">`+
                                            '             <i class="fa-solid fa-user-clock fs-1 '+(row['members'][i]['isBlocked'] === 1 ? 'text-grey-700' : '')+'"></i>'+
                                            '        </div>' +
                                            (!row['members'][i]['hasGateway'] ? '<span class="symbol-badge badge badge-circle bg-warning start-85 top-85 w-15px h-15px fs-7 text-center text-white" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>This Member is not assigned to any Gateway, so it does not have access to the perimeter</div>">!</span>' : '') +
                                            (row['members'][i]['isBlocked'] === 1 ? '<span class="symbol-badge badge badge-circle bg-danger start-85 top-85 w-15px h-15px fs-10 text-center text-white" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>blocked</div>">&#10005;</span>' : '') +
                                            '     </div>';
                                    }
                                } else {
                                    html += '<div class="symbol symbol-40px symbol-circle border ga-border-primary-300" id="'+row['uuid']+'" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>'+(row['members'].length - 3)+' more Members</div>">' +
                                        '        <div class="symbol-label bg-light-primary border border-2 border-white text-primary fs-6 fw-bolder">+'+(row['members'].length - 3)+'</div>'+
                                        '     </div>';
                                    break;
                                }
                            }
                            return html+'</div>';
                        }
                        return '';
                    }
                },
                {
                    data: 'lastUpdateDate',
                    title: 'Last Login Attempt',
                    className: 'min-w-90px',
                    sortable: true,
                    render: function (data, type, row) {
                        return `<span data-bs-toggle="popover" data-bs-trigger="hover" data-bs-placement="bottom" data-bs-content="${row['timezone']}">${row['lastUpdateDate']}</span>`;
                    }
                },
                {
                    data: null,
                    title: 'Action',
                    sortable: false,
                    render: function (data, type, row) {
                        let html = '<div class="datatable-action min-w-2" id="'+row['uuid']+'">';
                        if (row['edit']) {
                            html += '<div class="btn btn-icon btn-bg-light btn-sm me-2 btn-active-color-primary approve-device cursor-pointer" data-cy="approve-device-btn" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="Approve">'+
                                '           <span class="svg-icon svg-icon-3">' +
                                '               <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">'+
                                '                   <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"/>'+
                                '                   <path d="M10.4343 12.4343L8.75 10.75C8.33579 10.3358 7.66421 10.3358 7.25 10.75C6.83579 11.1642 6.83579 11.8358 7.25 12.25L10.2929 15.2929C10.6834 15.6834 11.3166 15.6834 11.7071 15.2929L17.25 9.75C17.6642 9.33579 17.6642 8.66421 17.25 8.25C16.8358 7.83579 16.1642 7.83579 15.75 8.25L11.5657 12.4343C11.2533 12.7467 10.7467 12.7467 10.4343 12.4343Z" fill="currentColor"/>'+
                                '               </svg>' +
                                '           </span>' +
                                '        </div>';
                            html += '<div class="btn btn-icon btn-bg-light btn-sm btn-active-color-primary delete-device cursor-pointer" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="Delete">'+
                                '                   <span class="svg-icon svg-icon-3">' +
                                '                       <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                                '                           <path d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z" fill="currentColor"></path>' +
                                '                           <path opacity="0.5" d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z" fill="currentColor"></path>' +
                                '                           <path opacity="0.5" d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z" fill="currentColor"></path>' +
                                '                       </svg>' +
                                '                   </span>' +
                                '               </div>';
                        }
                        return html+'</div>';
                    }
                }
            ]
        }).on('init.dt', function () {
            if(datatable.page.info().recordsTotal === 0){
                $('#denied-devices-datatable_wrapper').hide();
                $('#deniedDevices_wrapper [data-kt-docs-table-filter=search]').parent().hide();
                $('#denied-devices-datatable_no-results').addClass('d-flex flex-center flex-column').removeClass('d-none');
            }
        }).on('select', function () {
            let displayedRows = thisClass.datatable.rows({page:'current'}).count();
            let selectedRows = thisClass.datatable.rows({selected:true}).count();
            if(selectedRows === displayedRows){
                $('#denied-devices-datatable_wrapper [data-kt-check-all]').prop('checked', true);
            }
        }).on('deselect', function () {
            let displayedRows = thisClass.datatable.rows({page:'current'}).count();
            let selectedRows = thisClass.datatable.rows({selected:true}).count();
            if(selectedRows !== displayedRows){
                $('#denied-devices-datatable_wrapper [data-kt-check-all]').prop('checked', false);
            }
        }).on('draw', function () {
            thisClass.removeSelectedRows(organizationID);
            $('#denied-devices-datatable_wrapper [data-kt-check-all]').prop('checked', false);
            if(datatable.page.info().recordsTotal !== 0){
                $('#denied-devices-datatable_wrapper').show();
                $('#deniedDevices_wrapper [data-kt-docs-table-filter=search]').parent().show();
            } else {
                $('#denied-devices-datatable_wrapper').hide();
                $('#deniedDevices_wrapper [data-kt-docs-table-filter=search]').parent().hide();
                $('#denied-devices-datatable_no-results').addClass('d-flex flex-center flex-column').removeClass('d-none');
            }
            const container = document.querySelector('#denied-devices-datatable_wrapper');
            const selectedToolbar = container.querySelector('[data-kt-docs-table-toolbar="selected"]');
            if(selectedToolbar){
                selectedToolbar.classList.add('d-none');
            }
        });
        // Init and add delay to datatable search
        new DatatableSearchDelay(datatable, '[data-kt-docs-table-filter=search]');
        return datatable;
    }
    initActions(organizationID){
        const thisClass = this;

        /** Delete Device */
        $(document).on('click','#denied-devices-datatable .delete-device',function(e){
            let deviceID = $(this).parent()[0].id;
            let deviceName = $(this).closest('tr').find('span[data-device-name]').attr('data-device-name');
            Swal.fire({
                html: `<span class="text-center text-primary">Device `+(deviceName !== undefined ? `<b>`+deviceName+`</b> ` : ``)+`is going to be completely deleted!</span>`,
                icon: "warning",
                iconColor: "#FF5206",
                buttonsStyling: false,
                reverseButtons: true,
                showCancelButton: true,
                confirmButtonText: "Yes, delete it!",
                customClass: {
                    confirmButton: "btn btn-danger mt-0",
                    cancelButton: 'btn btn-light-primary mt-0',
                },
                showLoaderOnConfirm: true,
                returnFocus: false,
                preConfirm: () => {
                    return fetch('/devices?do=removeDevice&organizationID='+organizationID+'&deviceID='+deviceID+'&category=deviceApproval')
                        .then(response => {
                            if (!response.ok) {
                                throw new Error(response.statusText)
                            }
                            return response.json();
                        }).catch(error => {
                            Swal.showValidationMessage(`Request failed: ${error}`)
                        });
                },
                allowOutsideClick: () => !Swal.isLoading(),
                allowEscapeKey: () => !Swal.isLoading()
            }).then((result) => {
                if (result.isConfirmed) {
                    if(result.value) {
                        toastr.success('Device has been deleted.');
                        thisClass.datatable.ajax.reload(null, false);
                    } else {
                        toastr.error('Unexpected error occurred. Please try it again later or contact our support team.');
                    }
                }
            });
        });

        /** Approve Device */
        $(document).on('click','#denied-devices-datatable .approve-device',function(e){
            let deviceID = $(this).parent()[0].id;
            let deviceName = $(this).closest('tr').find('span[data-device-name]').attr('data-device-name');
            Swal.fire({
                html: `<span class="text-center text-primary">Device `+(deviceName !== undefined ? `<b>`+deviceName+`</b> ` : ``)+`is going to be approved!</span>`,
                icon: "warning",
                iconColor: "#FF5206",
                buttonsStyling: false,
                reverseButtons: true,
                showCancelButton: true,
                confirmButtonText: "Yes, approve it!",
                customClass: {
                    confirmButton: "btn btn-danger mt-0",
                    cancelButton: 'btn btn-light-primary mt-0',
                },
                showLoaderOnConfirm: true,
                returnFocus: false,
                preConfirm: () => {
                    return fetch('/device-approval?do=approveDevice&organizationID='+organizationID+'&deviceID='+deviceID)
                        .then(response => {
                            if (!response.ok) {
                                throw new Error(response.statusText)
                            }
                            return response.json();
                        }).catch(error => {
                            Swal.showValidationMessage(`Request failed: ${error}`)
                        });
                },
                allowOutsideClick: () => !Swal.isLoading(),
                allowEscapeKey: () => !Swal.isLoading()
            }).then((result) => {
                if (result.isConfirmed) {
                    if(result.value) {
                        toastr.success('Device has been approved.');
                        thisClass.datatable.ajax.reload(null, false);
                    } else {
                        toastr.error('Unexpected error occurred. Please try it again later or contact our support team.');
                    }
                }
            });
        });
    }
    removeSelectedRows(organizationID){
        const thisClass = this;
        // Toggle selected action toolbar
        // Select all checkboxes
        const container = document.querySelector('#deniedDevices_wrapper');
        const checkboxes = container.querySelectorAll('[type="checkbox"]');

        // Select elements
        const deleteSelected = container.querySelector('[data-kt-docs-table-select="delete_selected"]');
        const approveSelected = container.querySelector('[data-kt-docs-table-select="approve_selected"]');

        // Toggle delete selected toolbar
        checkboxes.forEach(c => {
            // Checkbox on click event
            c.addEventListener('click', function () {
                if (c.hasAttribute('data-kt-check-all')) {
                    if (c.checked) {
                        thisClass.datatable.rows().select();
                    } else {
                        thisClass.datatable.rows().deselect();
                    }
                }
                setTimeout(function () {
                    thisClass.toggleToolbars();
                }, 50);
            });
        });

        // Delete selected rows
        if(deleteSelected){
            deleteSelected.addEventListener('click', function () {
                let selectedIDs = thisClass.getSelectedIDs();
                Swal.fire({
                    html: `<span class="text-center text-primary">Are you sure you want to delete selected Devices?</span>`,
                    icon: "warning",
                    iconColor: "#FF5206",
                    buttonsStyling: false,
                    reverseButtons: true,
                    showCancelButton: true,
                    confirmButtonText: "Yes, delete!",
                    customClass: {
                        confirmButton: "btn btn-danger mt-0",
                        cancelButton: 'btn btn-light-primary mt-0',
                    },
                    showLoaderOnConfirm: true,
                    returnFocus: false,
                    preConfirm: () => {
                        return fetch('/devices?do=removeDevice&organizationID='+organizationID+(selectedIDs.length > 0 ? '&deviceIDs='+selectedIDs : '')+'&category=deviceApproval')
                            .then(response => {
                                if (!response.ok) {
                                    throw new Error(response.statusText)
                                }
                                return response.json();
                            }).catch(error => {
                                Swal.showValidationMessage(`Request failed: ${error}`)
                            });
                    },
                    allowOutsideClick: () => !Swal.isLoading(),
                    allowEscapeKey: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.isConfirmed) {
                        const headerCheckbox = container.querySelectorAll('[type="checkbox"]')[0];
                        headerCheckbox.checked = false;
                        container.querySelector('[data-kt-docs-table-toolbar="selected"]').classList.add('d-none');
                        if(result.value) {
                            toastr.success('Devices have been deleted.');
                            thisClass.datatable.ajax.reload();
                        } else {
                            toastr.error('Unexpected error occurred. Please try it again later or contact our support team.');
                        }
                    }
                });
            });
        }

        // Approve selected rows
        if(approveSelected){
            approveSelected.addEventListener('click', function () {
                let selectedIDs = thisClass.getSelectedIDs();
                Swal.fire({
                    html: `<span class="text-center text-primary">Are you sure you want to approve selected Devices?</span>`,
                    icon: "warning",
                    iconColor: "#FF5206",
                    buttonsStyling: false,
                    reverseButtons: true,
                    showCancelButton: true,
                    confirmButtonText: "Yes, approve!",
                    customClass: {
                        confirmButton: "btn btn-danger mt-0",
                        cancelButton: 'btn btn-light-primary mt-0',
                    },
                    showLoaderOnConfirm: true,
                    returnFocus: false,
                    preConfirm: () => {
                        return fetch('/device-approval?do=approveDevice&organizationID='+organizationID+(selectedIDs.length > 0 ? '&deviceIDs='+selectedIDs : ''))
                            .then(response => {
                                if (!response.ok) {
                                    throw new Error(response.statusText)
                                }
                                return response.json();
                            }).catch(error => {
                                Swal.showValidationMessage(`Request failed: ${error}`)
                            });
                    },
                    allowOutsideClick: () => !Swal.isLoading(),
                    allowEscapeKey: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.isConfirmed) {
                        const headerCheckbox = container.querySelectorAll('[type="checkbox"]')[0];
                        headerCheckbox.checked = false;
                        container.querySelector('[data-kt-docs-table-toolbar="selected"]').classList.add('d-none');
                        if(result.value) {
                            toastr.success('Devices have been approved.');
                            thisClass.datatable.ajax.reload();
                        } else {
                            toastr.error('Unexpected error occurred. Please try it again later or contact our support team.');
                        }
                    }
                });
            });
        }
    }
    toggleToolbars() {
        // Define variables
        const container = document.querySelector('#deniedDevices_wrapper');
        const toolbarSelected = container.querySelector('[data-kt-docs-table-toolbar="selected"]');
        if(toolbarSelected){
            const selectedCount = container.querySelector('[data-kt-docs-table-select="selected_count"]');

            // Select refreshed checkbox DOM elements
            const allCheckboxes = container.querySelectorAll('tbody [type="checkbox"]');

            // Detect checkboxes state & count
            let checkedState = false;
            let count = 0;

            // Count checked boxes
            allCheckboxes.forEach(c => {
                if (c.checked) {
                    checkedState = true;
                    count++;
                }
            });

            // Toggle toolbars
            if (checkedState) {
                selectedCount.innerHTML = count;
                toolbarSelected.classList.remove('d-none');
            } else {
                toolbarSelected.classList.add('d-none');
            }
        }
    }
    getSelectedIDs(){
        // Define variables
        const container = document.querySelector('#deniedDevices_wrapper');
        // Select refreshed checkbox DOM elements
        const allCheckboxes = container.querySelectorAll('tbody [type="checkbox"]');

        let devicesIDs = [];

        // Count checked boxes
        allCheckboxes.forEach(c => {
            if (c.checked) {
                devicesIDs.push(c.value);
            }
        });
        return devicesIDs;
    }
}
window.DeniedDevicesDatatable = DeniedDevicesDatatable;